import momentJalali from "moment-jalaali"
import momentHijri from "moment-hijri"
import * as momentRange from "moment-range"

import isInPosDevice from "./isInPosDevice"

const iranUtcTimeZoneOffset = 210

let momentWithRange =
  momentRange.extendMoment(momentJalali)

export const setMoment = (lang = "fa") => {
  momentWithRange =
    momentRange.extendMoment(
      lang === "ar" ? momentHijri : momentJalali
    )
}

const moment = (date) => {
  const d = date || undefined

  if (!isInPosDevice()) return momentWithRange(d)

  return momentWithRange(d).utcOffset(iranUtcTimeZoneOffset)
}

export default moment